import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';
import { Duration } from '../constants';

export interface UnbilledChargesResponse {
  total: number;
  unbilled_charges: UnbilledCharge[];
}

export interface UnbilledCharge {
  id: string;
  date: string;
  total?: number;
}
async function getWorkshopUnbilledCharges(axios: AxiosInstance, workshop_id: number): Promise<UnbilledChargesResponse> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/workshop/${workshop_id}/unbilled-charges`);
  return data;
}

export default function useWorkshopUnbilledChargesQuery(workshop_id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(workshop_id),
    queryFn: () => getWorkshopUnbilledCharges(axios, workshop_id),
    enabled: !!workshop_id,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnWindowFocus: true,
    refetchOnMount: 'always',
    staleTime: Duration.Minute * 5,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(workshop_id: number) {
  return ['UnbilledCharge', workshop_id] as const satisfies QueryKey;
}
useWorkshopUnbilledChargesQuery.getKey = getKey;
